export const PAGES = {
  LANDING: 'LANDING',
  EXPLORE: 'EXPLORE',
  EVENT: 'EVENT',
  PROFILE: 'PROFILE',
  LOGIN: 'LOGIN',
  MESSENGER: 'MESSENGER',
  FAQ: 'FAQ'
}
